<!--
  功能：星图账户授权列表
  作者：lost
  邮箱：lost@daoyoudao.com
  时间：2022年07月06日 16:58:25
  版本：v1.0
-->
<template>
  <div class="starAuth">
    <el-form ref="queryFormRef" class="query-form" :model="queryForm" :inline="true">
      <div class="formBox">
        <!-- <el-form-item label="广告账户/ID">
          <el-input class="accountNameInput" v-model.lazy="queryForm.agentAccountName" @blur="nameBlur" placeholder="请输入账户或ID" clearable @clear="getTabList"></el-input>
        </el-form-item> -->
        <el-form-item label="广告账户/ID">
        <el-select v-model="queryForm.agentAccountId" popper-class="starAccountSelect" style="width: 300px" @blur="accountBlur" :filter-method="queryAccount" @change="getTabList" filterable clearable @clear="clearAll" placeholder="请选择或输入投放账户/ID">
          <el-option v-for="item in accountData" :key="item.agentAccountId" :label="item.agentAccountName" :value="item.agentAccountId">
            <el-tooltip :content="item.agentAccountName" placement="left" effect="light">
              <p class="clearfix">
                <span class="left">{{ item.agentAccountName }}</span>
                <span class="right">{{ item.agentAccountId }}</span>
              </p>
            </el-tooltip>
          </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="账户状态" class="accountStatus">
          <el-select @change="statusChange" v-model="queryForm.status" collapse-tags filterable clearable placeholder="请选择" style="width: 170px">
            <el-option label="正常" :value="1"></el-option>
            <el-option label="暂停" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权状态" class="accountStatus">
          <el-select @change="statusChange" v-model="queryForm.isVaild" collapse-tags filterable clearable placeholder="请选择" style="width: 170px">
            <el-option label="正常" :value="1"></el-option>
            <el-option label="已失效" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <div class="fr" style="margin-top:3px;margin-bottom:22px;">
          <el-button type="primary" @click="authAccount" size="medium">
            <i class="iconfont icon-tianjia-copy"></i>
            <span>广告账户</span>
          </el-button>
        </div>
      </div>
    </el-form>
    <div class="tableBox">
      <el-table class="roleTable" :max-height="tabheight" :data="tabList" border v-loading="listLoading">
        <el-table-column prop="agentAccountName" label="账户名称" min-width="260">
          <template slot-scope="scope">
            <div class="editBox inputLong">
              <el-input
                :ref="`accNameRef-${scope.$index}`"
                v-if="scope.row.edit"
                @blur="editNameBlur(scope.row, 'edit', 'agentAccountName')"
                size="mini"
                maxlength="30"
                placeholder="请输入账户名称"
                v-model="scope.row.agentAccountName"
              />
              <span v-else>{{ scope.row.agentAccountName }}</span>
              &nbsp;&nbsp;
              <i :class="scope.row.agentAccountName ? 'el-icon-edit hidden' : 'el-icon-edit'" v-if="!scope.row.edit" @click="nameEdit(scope.row, 'edit', `accNameRef-${scope.$index}`, 'agentAccountName')"></i>
              <i class="el-icon-close" v-if="scope.row.edit" @click="cancelEdit(scope.row, 'edit', 'agentAccountName')"></i>
              <i class="el-icon-check" v-if="scope.row.edit"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="agentAccountId" label="账户ID" width="150"></el-table-column>
        <!-- <el-table-column prop="deviceType" label="同步状态" width="130">
          <template slot-scope="scope">
            <span :class="{'red':scope.row.syncStatus=='订单未同步','blue':scope.row.syncStatus=='订单同步中','green':scope.row.syncStatus=='订单已同步'}">{{scope.row.syncStatus}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="客户一级行业" width="220">
          <template slot-scope="scope">
            <div class="editBox inputShort">
              <el-input
                :ref="`cFNameRef-${scope.$index}`"
                v-if="scope.row.Fedit"
                @blur="editNameBlur(scope.row, 'Fedit', 'firstIndustryName')"
                size="mini"
                maxlength="20"
                placeholder="请输入行业名称"
                v-model="scope.row.firstIndustryName"
              />
              <span v-else>{{ scope.row.firstIndustryName }}</span>
              &nbsp;
              <i :class="scope.row.firstIndustryName ? 'el-icon-edit hidden' : 'el-icon-edit'" v-if="!scope.row.Fedit" @click="nameEdit(scope.row, 'Fedit', `cFNameRef-${scope.$index}`, 'firstIndustryName')"></i>
              <i class="el-icon-close" v-if="scope.row.Fedit" @click="cancelEdit(scope.row, 'edit', 'firstIndustryName')"></i>
              <i class="el-icon-check" v-if="scope.row.Fedit" @click="scope.row.Fedit = false"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="客户二级行业" width="220">
          <template slot-scope="scope">
            <div class="editBox inputShort">
              <el-input
                :ref="`cSNameRef-${scope.$index}`"
                v-if="scope.row.Sedit"
                @blur="editNameBlur(scope.row, 'Sedit', 'secondIndustryName')"
                size="mini"
                maxlength="20"
                placeholder="请输入行业名称"
                v-model="scope.row.secondIndustryName"
              />
              <span v-else>{{ scope.row.secondIndustryName }}</span>
              &nbsp;
              <i :class="scope.row.secondIndustryName ? 'el-icon-edit hidden' : 'el-icon-edit'" v-if="!scope.row.Sedit" @click="nameEdit(scope.row, 'Sedit', `cSNameRef-${scope.$index}`, 'secondIndustryName')"></i>
              <i class="el-icon-close" v-if="scope.row.Sedit" @click="cancelEdit(scope.row, 'edit', 'secondIndustryName')"></i>
              <i class="el-icon-check" v-if="scope.row.Sedit" @click="scope.row.Sedit = false"></i>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="deviceType" label="操作" width="150">
          <template slot-scope="scope">
            <div>
              <el-button @click="operation(scope.row)" type="text" size="small">同步订单</el-button>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="deviceType" label="账户状态" width="110">
          <!-- v-model="scope.row.status"  -->
          <template slot-scope="scope">
            <el-switch @change="accountStatusChange(scope.row)" :value="scope.row.status === 1"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="授权状态" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.isVaild === 0">已失效</span>
            <span v-else-if="scope.row.isVaild === 1">正常</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging-box" v-if="pageTotal > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 80, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
    <!-- 同步数据 -->
    <!-- <div class="syncData" v-if="syncDataVisible">
      <el-dialog title="同步订单" :visible.sync="syncDataVisible" :close-on-click-modal="false">
        <el-form ref="syncDataForm" :model="syncDataForm" :rules="syncDataRules">
          <el-form-item label="" prop="filterDate">
            <el-date-picker
              v-model="syncDataForm.filterDate"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="btn">
            <el-button size="small" @click="syncDataVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="syncDataSubmit()" :loading="btnloading">保 存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div> -->
  </div>
</template>

<script>
// import { dateValidation } from '@/components/form/formValidation'
import { getTime } from '@/components/public'
export default {
  // 组件名称
  name: 'index',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      btnloading: false,
      // syncDataId: 0,
      // syncDataForm: {
      //   filterDate: []
      // },
      // syncDataRules: {
      //   filterDate: [dateValidation('请选择您要同步数据的日期')]
      // },
      accountDataOld: [],
      accountData: [],
      syncDataVisible: false,
      tabheight: null,
      listLoading: false,
      // { id: 77, status: 1, accountId: '1234', agentAccountName: 'dsfsf', isVaild: 1, edit: false, firstIndustryName: '', secondIndustryName: '', Sedit: false, Fedit: false }
      tabList: [],
      queryForm: {
        agentAccountId: '',
        agentAccountName: '',
        status: '',
        isVaild: ''
      },
      // 分页相关
      currentPage: 1, // 初始当前显示页
      pagesize: 10, // 初始每页的数据条数
      pageTotal: 0 // 数据总条数
      // pickerOptions: {
      //   shortcuts: [
      //     {
      //       text: '最近一周',
      //       onClick(picker) {
      //         const end = new Date()
      //         end.setTime(end.getTime() - 3600 * 1000 * 24)
      //         const start = new Date()
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      //         picker.$emit('pick', [start, end])
      //       }
      //     },
      //     {
      //       text: '最近一个月',
      //       onClick(picker) {
      //         const end = new Date()
      //         end.setTime(end.getTime() - 3600 * 1000 * 24)
      //         const start = new Date()
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      //         picker.$emit('pick', [start, end])
      //       }
      //     },
      //     {
      //       text: '最近三个月',
      //       onClick(picker) {
      //         const end = new Date()
      //         end.setTime(end.getTime() - 3600 * 1000 * 24)
      //         const start = new Date()
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      //         picker.$emit('pick', [start, end])
      //       }
      //     }
      //   ]
      // }
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  emits: ['getOeAuthUrl'],
  // 组件方法
  methods: {
    clearAll() {
      console.log('clearAll')
      this.accountData = this.accountDataOld
    },
    syncDataSubmit() {
      this.$refs.syncDataForm.validate(valid => {
        if (valid) {
          let param = {
            beginTime: getTime(new Date(this.syncDataForm.filterDate[0])),
            endTime: getTime(new Date(this.syncDataForm.filterDate[1])),
            enterpriseAccountIds: this.syncDataId
          }
          this.btnloading = true
          this.$service.post('/api/account/star/sync/oeSyncStarDemandOrder', param).then(res => {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.getTabList()
            this.syncDataVisible = false
            this.btnloading = false
          }).catch(Err => {
            this.btnloading = false
          })
          // api/account/star/sync/oeSyncStarDemandOrder
        }
      })
      // btnloading
      // 同步数据
    },
    cancelEdit(row, key, nameKey) {
      console.log('cancelEdit', row['copy' + nameKey])
      row[nameKey] = row['copy' + nameKey]
      row[key] = false
    },
    nameEdit(row, key, refName, nameKey) {
      row[key] = true
      this.$nextTick(() => {
        this.$refs[refName].focus()
      })
      // 备份历史数据，用于取消时用
      if (nameKey) {
        row['copy' + nameKey] = row[nameKey]
      }
    },
    /**
     * 失去焦点事件与取消按钮点击事件冲突，加延迟解决。
     */
    editNameBlur(row, key, nameKey) {
      setTimeout(() => {
        console.log('editNameBlur', key)
        row[key] = false
        if (row[nameKey] !== row['copy' + nameKey]) {
          this.updateAccountInfo(row, nameKey)
        }
      }, 400)
    },
    async accountStatusChange(row) {
      row.status === 1 ? (row.status = 0) : (row.status = 1)
      try {
        const { code, message } = await this.$service.post('/api/account/status/update', {
          id: [row.id],
          status: row.status
        })
        if (code === 200) {
          this.$message.success('修改成功!')
        } else {
          this.$message.error(message)
          // 失败复原
          row.status === 1 ? (row.status = 0) : (row.status = 1)
        }
      } catch (error) {
        console.log(error)
        row.status === 1 ? (row.status = 0) : (row.status = 1)
        // this.$message.warning('修改失败!')
      }
    },
    async updateAccountInfo(row, key) {
      // row.status === 1 ? (row.status = 0) : (row.status = 1)
      try {
        let type = 0
        switch (key) {
          case 'agentAccountName':
            type = 1
            break
          case 'firstIndustryName':
            type = 2
            break
          case 'secondIndustryName':
            type = 3
            break
        }
        let params = {id: row.id, type: type}
        params[key] = row[key] ? row[key].trim() : ''
        const { code, message } = await this.$service.post('/api/account/star/updateAccountInfo', params)
        if (code === 200) {
          // this.$message.success('修改成功!')
        } else {
          this.$message.error(message)
          row[key] = row['copy' + key]
        }
      } catch (error) {
        row[key] = row['copy' + key]
        console.log(error)
      }
    },
    // // 同步订单数据
    // operation(row) {
    //   const start = new Date()
    //   const end = new Date()
    //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
    //   end.setTime(end.getTime() - 3600 * 1000 * 24)
    //   this.syncDataForm.filterDate = [getTime(start), getTime(end)]
    //   this.pickerOptions.disabledDate = time => {
    //     return time.getTime() < start.getTime() || time.getTime() > new Date().getTime() - 3600 * 1000 * 24
    //   }
    //   this.syncDataId = row.id
    //   this.syncDataVisible = true
    // },
    // 获取投放项目列表
    getTabList () {
      this.putInAccountManageParam = {
        'agentAccountName': this.queryForm.agentAccountName,
        'agentAccountId': this.queryForm.agentAccountId,
        'pageNum': this.currentPage,
        'pageSize': this.pagesize,
        'status': this.queryForm.status,
        'isVaild': this.queryForm.isVaild,
        // 'isVaild': this.filterParam.isVaild,
        platformType: 3
      }
      this.$service.post('/api/account/starList', this.putInAccountManageParam).then(res => {
        res.result.pageData.forEach((item, index) => {
          item.edit = false
          item.Sedit = false
          item.Fedit = false
          // item.syncStatus = this.getSyncStatus(item.syncStatus, '订单')
        })
        console.log('getTabList', res.result.pageData)
        this.tabList = res.result.pageData
        this.pageTotal = res.result.total
        if (this.tabList.length > 4) {
          this.updatetabheight()
        } else {
          this.tabheight = null
        }
      }).catch(Err => {
        console.log(Err)
      })
    },
    accountBlur() {
      if (!this.queryForm.agentAccountId) {
        this.accountData = this.accountDataOld
      }
    },
    // 搜索投放账户
    queryAccount (val) {
      console.log('queryAccount', val)
      if (val !== '') {
        this.accountData = this.accountDataOld.filter(item => item.agentAccountName.indexOf(val) !== -1 || item.agentAccountId.indexOf(val) !== -1)
      } else {
        this.accountData = this.accountDataOld
      }
    },
    // 获取投放账户
    getAccountListByPlatform () {
      this.$service.post('/api/star/order/getAccountListByPlatform', {id: 3}).then(res => {
        if (res.code === 200) {
          res.result.forEach(item => {
            if (item.agentAccountName === '') item.agentAccountName = '未获取'
          })
          this.accountDataOld = res.result
          this.accountData = res.result
        }
      }).catch(Err => {})
    },
    // 获取同步状态
    // getSyncStatus (status, name) {
    //   if (status === 0) {
    //     return name + '未同步'
    //   } else if (status === 1) {
    //     return name + '同步中'
    //   } else if (status === 2) {
    //     return name + '已同步'
    //   }
    // },
    updatetabheight() {
      if (!this.tabheight) {
        let height = document.documentElement.clientHeight
        let offsetTop = this.$refs.table.$el.getBoundingClientRect().top
        console.log('offsetTop', offsetTop)
        this.$nextTick(() => {
          this.tabheight = parseInt(height - offsetTop - 20)
        })
      }
    },
    // getTabList() {},
    statusChange() {
      this.getTabList()
    },
    nameBlur() {
      this.getTabList()
    },
    authAccount() {
      console.log('authAccount')
      this.$emit('getOeAuthUrl', '')
    },
    // 切换数据显示条数
    handleSizeChange(size) {
      this.pagesize = size
      this.getTabList()
    },
    // 切换分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getTabList()
    }
  },
  // 组件在内存中被创建
  created() {
    this.getTabList()
    this.getAccountListByPlatform()
  },
  /**
   * 组件被渲染到页面
   */
  mounted() {}
}
</script>

<style lang="less" scoped>
.starAuth {
  .tableBox {
    margin-top: -20px;
    tr{
      .editBox{
        position: relative;
        // cursor: pointer;
        .hidden{
          position: absolute;
          margin-left: 5px;
          opacity: 0;
          color: blue;
          cursor: pointer;
        }
      }
      &:hover{
        td{
          .editBox{
            .hidden{
              display: inline-block;
              opacity: 1;
            }
          }
        }
      }
    }
  }
  /deep/ .formBox {
    margin-top: 10px;
    .el-input__prefix,
    .el-input__suffix {
      height: auto;
    }
    .accountNameInput {
      width: 220px;
    }
    .el-input__inner {
      width: 220px;
      height: 35px;
    }
    .el-select {
      // width: 180px;
      height: 35px;
      .el-input__inner {
        // width: 160px;
        width: 100%;
        height: 35px;
      }
    }
    .accountStatus {
      margin-left: 30px;
    }
    .editBtn {
      display: inline-block;
      padding-left: 25px;
      padding-right: 10px;
      margin-right: 10px;
    }
  }
  .editBox {
    i {
      font-size: 14px;
      cursor: pointer;
    }
  }
  .inputShort {
    /deep/ .el-input__inner {
      width: 140px;
      padding-left: 2px;
      padding-right: 2px;
      border-radius: 1px;
    }
  }
  .inputLong {
    /deep/ .el-input__inner {
      width: 210px;
      padding-left: 2px;
      padding-right: 2px;
      border-radius: 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/accountManage/starAuth/index.vue